export default __webpack_public_path__ + "static/media/image7.6ad2fede.jpg";